import React from 'react'
import { connect } from 'react-redux'
import leftPad from 'left-pad'
import { WkPanel } from '../../components/wk'


class ChannelGroupBuyList extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            foo: null,
        }
    }

    componentDidMount () {
        this.timer = setInterval(() => {
            this.setState({ foo: 1 })
        }, 1000)
    }

    componentWillUnmount () {
        clearInterval(this.timer)
    }

    getDeadline (deadline) {
        const offset = deadline - Date.now() / 1000
        if (offset < 0) {
            this.setState({ 
                deadlineInfo: { 
                    hour: '00', 
                    minute: '00', 
                    second: '00',
                }
            })
            setTimeout(() => {
                this.fetchChannelInfo(true)
            }, 1000)
            clearInterval(this.timer)
            return
        }
        const hour = Math.floor(offset / 3600) 
        const minute = Math.floor((offset - hour * 3600) / 60)
        const second = Math.floor((offset - hour * 3600 - minute * 60))
        return `${leftPad(hour, 2, '0')}:${leftPad(minute, 2, '0')}:${leftPad(second, 2, '0')}`
    }

    onClickTip () {
        this.props.dispatch({
            type: 'CHANNEL_SET_IS_SHOW_GROUP_BUY_LIST_MODAL',
            payload: true,
        })
    }

    onClickJoin (id) {
        location.assign(`/channel/group_buy?id=${id}`)
    }

    getName (name) {
        if (name.length > 5) {
            return `${name.slice(0, 5)}...`
        } else {
            return name
        }
    }

    render() {
        const { channelGroupBuyList } = this.props
        return (
            <div className="channel-group-buy-list">
                <WkPanel 
                    title='以下小伙伴已拼团，可直接拼团' 
                    tip='查看更多'
                    isNoPadding={true}
                    onClickTip={e => this.onClickTip()}
                    isHideTip={channelGroupBuyList.length <= 2}
                    className={channelGroupBuyList.length > 2 ? 'gt2' : ''}
                >
                    {
                        channelGroupBuyList.slice(0, 2).map(item => (
                            <div className="channel-group-buy-item wk-border-line-after" key={item.id}>
                                <div className="left">
                                    <div className="avatar">
                                        <img src={item.leader.avatar_url} alt=""/>
                                    </div>
                                    <div className="name">{this.getName(item.leader.nickname)}</div>
                                </div>
                                <div className="right">
                                    <div className="right-left">
                                        <div className="remain">还差<span className='red'>{item.remain_num}人</span>成团</div>
                                        {
                                            Date.now() / 1000 > item.deadline && <div className="time">已结束</div>
                                        }
                                        {
                                            Date.now() / 1000 <= item.deadline && (
                                                <div className="time">
                                                    剩余{this.getDeadline(item.deadline)}结束
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="right-right">
                                        <div className="join-btn" onClick={e => this.onClickJoin(item.id)}>
                                            拼团
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </WkPanel>
            </div>
        )
    }
}

export default connect(state => ({
    
}))(ChannelGroupBuyList)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelGroupBuyList.js